import React, { Component } from 'react';

import { withStyles } from '@material-ui/core/styles';
import { Theme } from '@material-ui/core/styles/createMuiTheme';
import {
	WithStyles,
	createStyles,
	Grid,
	Typography,
	FormControlLabel,
	Checkbox,
} from '@material-ui/core';
import {
	Close as CloseIcon,
} from '@material-ui/icons';
import {
	MyPATDialog,
	MyPATIconButton,
	MyPATTextField
} from '../../common';
import courseServices from '../services/courseService';

const styles = (theme:Theme) => createStyles({
	dialogCloseContainer: {
		textAlign: 'right',
	},
	scheduleCard: {
		backgroundColor: '#f7f7f7',
		marginTop: theme.spacing.unit * 2,
		boxShadow: theme.shadows[1],
		'& > :nth-child(1)': {
			textAlign: 'center',
		},
		'& > :nth-child(2)': {
			...theme.mixins.gutters(),
			paddingTop: theme.spacing.unit * 2,
			paddingBottom: theme.spacing.unit * 2,
			backgroundColor: '#fbfbfb',
		}
	},
});

interface ScheduleDialogProps extends WithStyles<typeof styles> {
	isOpen: boolean,
	handleClose: () => void,
	contentId: string,
	handleListContent: () => void,
}

interface ScheduleDialogState {
	testStartDate: any,
	testStartTime: any,
	testEndDate: any,
	testEndTime: any,
	isWindowTestSelected: boolean,
}

class ScheduleDialog extends Component<ScheduleDialogProps, ScheduleDialogState> {
	constructor(props:ScheduleDialogProps) {
		super(props);
		this.state = {
			testStartDate: null,
			testStartTime: null,
			testEndDate: null,
			testEndTime: null,
			isWindowTestSelected: false,
		}

		this.handleScheduleSaveClick = this.handleScheduleSaveClick.bind(this);
		this.handleInputChange = this.handleInputChange.bind(this);
	}

	handleScheduleSaveClick = () => {
		let paramDetail = this.getParamsDetail();
		const postData = {
			"packageId": paramDetail.courseID,
			"milestoneId": paramDetail.milestoneId,
			testStartDate: this.state.testStartDate,
			testStartTime: this.state.testStartTime,
			testEndDate: this.state.testEndDate,
			testEndTime: this.state.testEndTime,
			isWindowTestSelected: this.state.isWindowTestSelected,
			contentId: this.props.contentId,
		}

		courseServices.scheduleTest(postData).then(() => { 
			this.props.handleListContent()
			this.props.handleClose();
			
		 });
	}

	getParamsDetail() {
		let courseIDArr = window.location.href.split("/")
		return { courseID: courseIDArr[5], milestoneId: courseIDArr[6] };
	}
	handleInputChange = (evt:any) => {
		const {name, value} = evt.target;
		this.setState(() => ({ [name]: value }));
	}

	handleOnlyWindowChange = (evt:any, checked:boolean) => {
		this.setState({
			testStartTime: null,
			testEndDate: null,
			testEndTime: null,
			isWindowTestSelected: checked
		});
	}
	
	render() {
		const { classes } = this.props;

		return (
			<>
				<MyPATDialog
					dialogOpen={this.props.isOpen}
					otherDialogProps={{
						fullWidth: true,
						maxWidth: 'md',
					}}
					onDialogClose={this.props.handleClose}
					onDialogSave={this.handleScheduleSaveClick.bind(this)}
					labelSaveButton="Schedule Test"
					variant="white"
					customDialogTitle={
						<Grid container justify="space-between" alignItems="center">
							<Grid item xs>
								<Typography variant="h6">
									Schedule Milestone Test
								</Typography>
							</Grid>

							<Grid item xs="auto" className={classes.dialogCloseContainer}>
								<MyPATIconButton buttonVariant="flat" onClick={this.props.handleClose}>
									<CloseIcon />
								</MyPATIconButton>
							</Grid>
						</Grid>
					}
				>
					<Grid container alignItems="center" className={classes.scheduleCard}>
						<Grid item xs={4}>
							<img src="/assets/img/course/calendar_big.png" alt="Calendar image" />
							<Typography variant="h5">
								Test Date
							</Typography>
							{this.state.isWindowTestSelected ? (
								<Typography variant="h5">
									&amp;<br/>Time
								</Typography>
							) : null}
						</Grid>

						<Grid item xs={8}>
							<Grid container spacing={8}>
								<Grid item xs={12}>
									<Typography variant="body1">Test Live Date</Typography>
									<Typography variant="caption">Test will be unavailable before this date</Typography>
								</Grid>

								<Grid item xs={6}>
									<MyPATTextField
										fullWidthControl
										type="date"
										variant="outlined"
										name="testStartDate"
										inputId="testStartDate"
										value={this.state.testStartDate}
										onChange={this.handleInputChange.bind(this)}
									/>
								</Grid>

								{this.state.isWindowTestSelected ? (
									<Grid item xs={6}>
										<MyPATTextField
											fullWidthControl
											type="date"
											variant="outlined"
											name="testEndDate"
											inputId="testEndDate"
											value={this.state.testEndDate}
											onChange={this.handleInputChange.bind(this)}
										/>
									</Grid>
								) : null}

								<Grid item xs={12}>
									<FormControlLabel
										label="Only available in a time window"
										control={
											<Checkbox
												checked={this.state.isWindowTestSelected}
												onChange={this.handleOnlyWindowChange.bind(this)}
												color="primary"
											/>
										}
									/>
								</Grid>

								{this.state.isWindowTestSelected ? (
									<>
										<Grid item xs={12}>
											<Typography variant="body1">Test Live window</Typography>
										</Grid>

										<Grid item xs={6}>
											<MyPATTextField
												fullWidthControl
												type="time"
												variant="outlined"
												name="testStartTime"
												inputId="testStartTime"
												value={this.state.testStartTime}
												onChange={this.handleInputChange.bind(this)}
											/>
										</Grid>

										<Grid item xs={6}>
											<MyPATTextField
												fullWidthControl
												type="time"
												variant="outlined"
												name="testEndTime"
												inputId="testEndTime"
												value={this.state.testEndTime}
												onChange={this.handleInputChange.bind(this)}
											/>
										</Grid>
									</>
								) : null}
							</Grid>
						</Grid>
					</Grid>
				</MyPATDialog>
			</>
		)
	}
}

// @ts-ignore
export default withStyles(styles)(ScheduleDialog);